__turbopack_context__.v({
  "content": "TurnrAlert-module-scss-module__eh1R5a__content",
  "content-wrapper": "TurnrAlert-module-scss-module__eh1R5a__content-wrapper",
  "popup-ERROR": "TurnrAlert-module-scss-module__eh1R5a__popup-ERROR",
  "popup-SUCCESS": "TurnrAlert-module-scss-module__eh1R5a__popup-SUCCESS",
  "popup-WARNING": "TurnrAlert-module-scss-module__eh1R5a__popup-WARNING",
  "popup-content": "TurnrAlert-module-scss-module__eh1R5a__popup-content",
  "popup-header": "TurnrAlert-module-scss-module__eh1R5a__popup-header",
  "popup-hide": "TurnrAlert-module-scss-module__eh1R5a__popup-hide",
  "popup-inner": "TurnrAlert-module-scss-module__eh1R5a__popup-inner",
});
